import axios from 'axios';
import {LanguageObject} from "@/i18n";
import {AutomatedEmail} from "@/utils/EmailUtils";

interface ContactInfo {
    contactLogin?: LanguageObject;
    contactMenu?: LanguageObject;
}

const api = {
    get: async() => {
        const resp = await axios.get<ContactInfo>(
            '/deployment/contactInfo/get.php'
        );
        return resp.data;
    },

    update: async(contactInfo: Partial<ContactInfo>) => {
        const resp = await axios.post<AutomatedEmail>(
            '/deployment/contactInfo/update.php',
            contactInfo
        );
        return resp.data;
    }
}

export default {
    api
}

export { ContactInfo }